import {idmsApi} from "./api";
import {
  API_FEATURE_ENDPOINT,
  API_PRODUCT_ENDPOINT,
} from "../../constants/endpoints";
import {convertObjectToQueryParams} from "../../util/convertObjectToQueryParams";

const productApi = idmsApi.injectEndpoints({
  endpoints: builder => ({
    updateFeature: builder.mutation<any, UpdateProductFeatureReq>({
      query: ({productFeatureId, productFeature}) => ({
        url: `${API_FEATURE_ENDPOINT}/${productFeatureId}`,
        method: "PUT",
        body: productFeature,
      }),
      // Invalidate product features and subscription features so updates appear immediately
      invalidatesTags: ["ProductFeatures", "SubscriptionFeatures"],
    }),

    deleteFeature: builder.mutation<any, string>({
      query: featureId => ({
        url: `${API_FEATURE_ENDPOINT}/${featureId}`,
        method: "DELETE",
      }),
      // Invalidate all caches that might display this feature
      invalidatesTags: ["ProductFeatures", "SubscriptionFeatures"],
    }),

    getAllProdcutsFeatures: builder.query<
      PaginatedProductsWithFeaturesDto,
      {page: number; pageSize: number}
    >({
      query: ({page, pageSize}) => ({
        url: `${API_PRODUCT_ENDPOINT}/products/features?${convertObjectToQueryParams(
          {
            page,
            pageSize,
          },
        )}`,
        method: "GET",
      }),
      // Provide tag so create/update/delete mutations can invalidate this list
      providesTags: ["ProductFeatures"],
    }),
  }),
});

export const {
  useUpdateFeatureMutation,
  useDeleteFeatureMutation,
  useGetAllProdcutsFeaturesQuery,
} = productApi;
